"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = _interopRequireDefault(require("@trs/config"));
var _general = require("@trs/utils/lib/general");
var _Input = _interopRequireDefault(require("./Input.style"));
var _InputError = _interopRequireDefault(require("../errors/InputError"));
var _Textarea = _interopRequireDefault(require("./Textarea"));
var _HelpText = _interopRequireDefault(require("./HelpText"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable */

var INPUT_MAX_LENGTH = _config["default"].INPUT_MAX_LENGTH,
  TEXTAREA_MAX_LENGTH = _config["default"].TEXTAREA_MAX_LENGTH;
var Input = /*#__PURE__*/function (_PureComponent) {
  _inherits(Input, _PureComponent);
  var _super = _createSuper(Input);
  function Input(props) {
    var _this;
    _classCallCheck(this, Input);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (event) {
      var newEvent = event;
      if (_this.props.type === 'number') {
        var regex = /^-?[0-9]*\.?[0-9]*/;
        var value = event.target.value;
        value = _this.state.isInputFocused ? value : (0, _general.removeNumberFormatting)(value);
        var m = regex.exec(value);
        value = m && m[0] ? m[0] : '';
        newEvent.target.value = value;
      }
      if (_this.props.onChange) {
        _this.props.onChange(newEvent);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "formatValue", function (value, type, isInputFocused, withLocaleFormatNumber) {
      if (!withLocaleFormatNumber || isInputFocused || type !== 'number' && type !== 'percentage') return value;
      return type === 'percentage' ? (0, _general.formatNumber)(value).concat('%') : (0, _general.formatNumber)(value);
    });
    _this.state = {
      isInputFocused: false
    };
    return _this;
  }
  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        autoFocus = _this$props.autoFocus,
        clearable = _this$props.clearable,
        classNameProp = _this$props.className,
        disabledProp = _this$props.disabled,
        disableUnderline = _this$props.disableUnderline,
        errors = _this$props.errors,
        fullWidth = _this$props.fullWidth,
        id = _this$props.id,
        icon = _this$props.icon,
        iconClick = _this$props.iconClick,
        _this$props$inputProp = _this$props.inputProps,
        _this$props$inputProp2 = _this$props$inputProp === void 0 ? {} : _this$props$inputProp,
        inputPropsClassName = _this$props$inputProp2.className,
        inputPropsProp = _objectWithoutProperties(_this$props$inputProp2, _excluded),
        multiline = _this$props.multiline,
        name = _this$props.name,
        onBlur = _this$props.onBlur,
        onFocus = _this$props.onFocus,
        onClick = _this$props.onClick,
        onKeyDown = _this$props.onKeyDown,
        onKeyUp = _this$props.onKeyUp,
        onPaste = _this$props.onPaste,
        placeholder = _this$props.placeholder,
        readOnly = _this$props.readOnly,
        required = _this$props.required,
        type = _this$props.type,
        value = _this$props.value,
        helpText = _this$props.helpText,
        scrollable = _this$props.scrollable,
        inputAriaLabel = _this$props.inputAriaLabel,
        submitIconAriaLabel = _this$props.submitIconAriaLabel,
        withLocaleFormatNumber = _this$props.withLocaleFormatNumber;
      var maxLength = this.props.maxLength;
      var InputComponent = 'input';
      var inputProps = _objectSpread({}, inputPropsProp);
      var isNumber = type === 'number' || type === 'percentage';
      var handleOnFocus = function handleOnFocus(ev) {
        _this2.setState({
          isInputFocused: true
        });
        onFocus && onFocus(ev);
      };
      var handleOnBlur = function handleOnBlur(ev) {
        _this2.setState({
          isInputFocused: false
        });
        onBlur && onBlur(ev);
      };
      if (multiline) {
        InputComponent = _Textarea["default"];
        maxLength = maxLength || TEXTAREA_MAX_LENGTH;
      } else {
        InputComponent = _Input["default"];
        maxLength = maxLength || INPUT_MAX_LENGTH;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-component"
      }, /*#__PURE__*/_react["default"].createElement(InputComponent, _extends({
        "aria-required": required,
        "aria-label": inputAriaLabel || placeholder,
        autoFocus: autoFocus,
        className: classNameProp,
        clearable: clearable,
        disabled: disabledProp,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        id: id,
        icon: icon,
        name: name,
        onBlur: handleOnBlur,
        onChange: this.handleOnChange,
        onFocus: handleOnFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onPaste: onPaste,
        onClick: onClick,
        placeholder: placeholder,
        readOnly: readOnly,
        type: isNumber ? undefined : type,
        value: this.formatValue(value, type, this.state.isInputFocused, withLocaleFormatNumber),
        hasErrors: Array.isArray(errors) ? errors.length > 0 : !!errors,
        maxLength: maxLength,
        scrollable: scrollable,
        autoComplete: "off"
      }, inputProps)), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "input-icon",
        icon: icon,
        "aria-label": submitIconAriaLabel || 'Submit input content',
        onClick: function onClick() {
          !disabledProp && iconClick('submit');
        },
        disabled: disabledProp
      }), clearable && value && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        id: "".concat(id, "Clear"),
        icon: "ion-android-close",
        className: "input-clear-icon",
        "aria-label": "Clear input",
        onClick: function onClick() {
          !disabledProp && _this2.handleOnChange({
            target: {
              value: ''
            }
          });
          iconClick('clear');
        },
        disabled: disabledProp
      }), errors ? Array.isArray(errors) ? errors.map(function (error, index) {
        return /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
          key: "".concat(index, "-").concat(error),
          id: "".concat(id, "Error").concat(index),
          message: error
        });
      }) : /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        message: errors,
        id: "".concat(id, "Error0")
      }) : null, helpText && !errors.length ? /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
        message: helpText
      }) : null);
    }
  }]);
  return Input;
}(_react.PureComponent);
Input.defaultProps = {
  autoFocus: false,
  className: '',
  placeholder: '',
  clearable: false,
  disableUnderline: false,
  id: '',
  value: '',
  type: 'text',
  disabled: false,
  inputProps: undefined,
  name: undefined,
  icon: undefined,
  maxLength: undefined,
  iconClick: function iconClick() {},
  multiline: false,
  errors: null,
  required: false,
  fullWidth: false,
  readOnly: false,
  onKeyUp: undefined,
  onKeyDown: undefined,
  onFocus: undefined,
  onChange: undefined,
  onBlur: undefined,
  helpText: '',
  scrollable: false,
  inputAriaLabel: '',
  submitIconAriaLabel: '',
  withLocaleFormatNumber: false
};
Input.propTypes = {
  /** If `true`, the input will be focused during the first mount. */
  autoFocus: _propTypes["default"].bool,
  /** The CSS class name of the wrapper element. */
  className: _propTypes["default"].string,
  /** Flag to indicate if the input should have a clearvalue action. */
  clearable: _propTypes["default"].bool,
  /** If `true`, the input will be disabled. */
  disabled: _propTypes["default"].bool,
  /** If `true`, the input will not have an underline. */
  disableUnderline: _propTypes["default"].bool,
  /** If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl. */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /** If `true`, the input will take up the full width of its container. */
  fullWidth: _propTypes["default"].bool,
  /** The id of the `input` element. */
  id: _propTypes["default"].string,
  /** An icon name to be rendered next to the input. */
  icon: _propTypes["default"].string,
  /** An action to perform when clicking on the icon on the clear button */
  iconClick: _propTypes["default"].func,
  /** Properties applied to the `input` element. */
  inputProps: _propTypes["default"].shape({}),
  /** If `true`, a textarea element will be rendered. */
  multiline: _propTypes["default"].bool,
  /** Name attribute of the `input` element. */
  name: _propTypes["default"].string,
  /** Action to perform on blur */
  onBlur: _propTypes["default"].func,
  /** Callback fired when the value is changed.
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`. */
  onChange: _propTypes["default"].func,
  /** Action to perform on focus */
  onFocus: _propTypes["default"].func,
  /** Action to perform on key down */
  onKeyDown: _propTypes["default"].func,
  /** Action to perform on key up */
  onKeyUp: _propTypes["default"].func,
  /** The short hint displayed in the input before the user enters a value. */
  placeholder: _propTypes["default"].string,
  /** Flag to indicate if the input is required */
  required: _propTypes["default"].bool,
  /** Flag to indicate if the input is read only */
  readOnly: _propTypes["default"].bool,
  /** Type of the input element. It should be a valid HTML5 input type. */
  type: _propTypes["default"].string,
  /** The input value, required for a controlled component. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),
  /** The native max length for text area */
  maxLength: _propTypes["default"].number,
  /** Small line of text */
  helpText: _propTypes["default"].string,
  scrollable: _propTypes["default"].bool,
  inputAriaLabel: _propTypes["default"].string,
  submitIconAriaLabel: _propTypes["default"].string,
  withLocaleFormatNumber: _propTypes["default"].bool
};
Input.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleOnChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "formatValue",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }, {
      "name": "type",
      "type": null
    }, {
      "name": "isInputFocused",
      "type": null
    }, {
      "name": "withLocaleFormatNumber",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Input",
  "props": {
    "autoFocus": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the input will be focused during the first mount.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The CSS class name of the wrapper element.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The short hint displayed in the input before the user enters a value.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "clearable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if the input should have a clearvalue action.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disableUnderline": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the input will not have an underline.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The id of the `input` element.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The input value, required for a controlled component.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }]
          }
        }]
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'text'",
        "computed": false
      },
      "description": "Type of the input element. It should be a valid HTML5 input type.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the input will be disabled.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "inputProps": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Properties applied to the `input` element.",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Name attribute of the `input` element.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "An icon name to be rendered next to the input.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "maxLength": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The native max length for text area",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "iconClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "An action to perform when clicking on the icon on the clear button",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "multiline": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, a textarea element will be rendered.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "If `true`, the input will indicate an error. This is normally obtained via context from\r\nFormControl.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if the input is required",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "fullWidth": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true`, the input will take up the full width of its container.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if the input is read only",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onKeyUp": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Action to perform on key up",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onKeyDown": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Action to perform on key down",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onFocus": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Action to perform on focus",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Callback fired when the value is changed.\r\n@param {object} event The event source of the callback.\r\nYou can pull out the new value by accessing `event.target.value`.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onBlur": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Action to perform on blur",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "helpText": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Small line of text",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "scrollable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "inputAriaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "submitIconAriaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "withLocaleFormatNumber": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};
var _default = Input;
exports["default"] = _default;